import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ValidateUserEmail, ValidateUserEmailResponse } from '@/model';
import { withZBSignature } from '@/service/zbSignature';
import { axiosInstance } from '../axios';

const key = ['VALIDATE_USER_EMAIL'];

export const useValidateUserEmail = () =>
	useMutation({
		mutationKey: [...key],
		mutationFn: async (input: ValidateUserEmail): Promise<ValidateUserEmailResponse> => {
			const payload = {
				email: input.email || undefined,
				click_id: input.click_id || undefined,
				lander_id: input.lander_id || undefined,
				affiliate_id: input.affiliate_id || undefined,
				source_id: input.source_id || undefined,
				username: input.username || undefined,
				password: input.password || undefined,
				password_confirmation: input.password_confirmation || undefined,
				profile: {
					gender: input.gender || undefined,
					city: input.city || undefined,
					zip_code: input.zip_code || undefined,
					birthday: input.birthday || undefined,
					seeking: input.seeking || undefined,
				},
			};

			const signedPayload = await withZBSignature(payload);

			const { data } = await axiosInstance.post('auth/member/validate-email', signedPayload, {
				headers: { doNotAddUserTokenAuthorization: true },
			});

			return data;
		},
		onError: (error: AxiosError<{ errors: Record<string, string[]> }>) =>
			console.log(error),
	});